const firstFilled = (...values) => values.find((value) => value != null && String(value).trim() !== "");
const numberOf = (value) => Number(String(value ?? "").replace(",", "."));

export const contractRates = (contrat = {}) => {
  const paid = firstFilled(
    contrat.TauxHorairePaye,
    contrat.TauxPaye,
    contrat.tauxHoraire,
    contrat.SalaireReference,
    contrat.TauxHoraireRef,
    contrat.TabHeures?.[0]?.TauxPaye,
  );
  const coefficient = firstFilled(contrat.CoeffHeures, contrat.coefficient);
  const computed = numberOf(paid) * numberOf(coefficient);
  const billed = firstFilled(contrat.TauxHoraireFacture, contrat.TauxFacture, contrat.tauxFacture, Number.isFinite(computed) && computed > 0 ? computed : null);
  return { paid, coefficient, billed };
};
